import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Libraries
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Styles
import "@/styles/index.scss";

function setupLibraries(): void {
  Vue.use(BootstrapVue);
  Vue.use(IconsPlugin);
}

setupLibraries();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
